import EditFanTagsModal from './EditFanTagsModal';

export default EditFanTagsModal;
